<template>
  <section ref="android11" class="android11">
    <div class="android11-img">
      <video v-if="!vm.isMobile" ref="video" muted="muted" preload="metadata" class="visibility-hidden">
        <source src="../../assets/banner/android11Logo.mp4" type="video/mp4" />
      </video>
      <img v-if="vm.isMobile && startGif" v-lazy="require('../../assets/banner/android11Logo.gif')" alt="ColorOS 11" />
    </div>
    <div v-textMotion="vm.isMobile ? 100 : 300" class="android11-text-intro">
      <p class="sub-title">
        {{ $t('android11-sub-title') }}
      </p>
      <p class="description">
        {{ $t('android11-description') }}
        <sup v-if="!vm.config.hide10Remark">10</sup>
      </p>
    </div>
  </section>
</template>

<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';

export default {
  inject: {
    vm: { default: { config: {} } }
  },
  data() {
    return {
      startGif: false,
      giftimer: 0
    };
  },
  mounted() {
    const _this = this;
    if (this.vm.isMobile) {
      this.$refs.android11.style.height = Math.min(450, 0.8 * window.innerHeight) + 'px';
      setTimeout(() => {
        new ScrollMagic.Scene({
          triggerElement: '.android11-img',
          triggerHook: 1,
          offset: 100
        })
          .addTo(Controller)
          .on('enter', () => {
            _this.giftimer++;
            _this.startGif = true;
          });
      }, 10);
    } else {
      const dom = this.$refs.video;
      new ScrollMagic.Scene({
        triggerElement: '.android11-img',
        triggerHook: 1,
        offset: 0.3 * window.innerHeight
      })
        .addTo(Controller)
        .on('enter', () => {
          dom.className = 'textInPartMotion';
          if (dom.play && dom.currentTime < 0.1) {
            setTimeout(() => {
              dom.play();
            }, 100);
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.android11 {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.android11-text-intro {
  padding-top: 84px;
  .description {
    max-width: 588px;
  }
}
.android11-img {
  width: 62.03vw;
  max-width: 893px;
  video,
  img {
    width: 100%;
    animation-duration: 1s;
  }
}
@media screen and (max-width: 734px) {
  .android11 {
    height: 80vh;
  }
  .android11-img {
    width: 85vw;
  }
  .android11-text-intro {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
    .sub-title {
      max-width: 62.7vw;
    }
  }
}
</style>
